// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.maateen.me/solaiman-lipi/font.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Poppins", "SolaimanLipi", sans-serif;
  font-size: 1rem;
  line-height: 1.3;
}

.custom-container {
  width: 100%;
  height: 100%;
  margin-right: auto;
  margin-left: auto;
}
@media (max-width: 375.98px) {
  .custom-container {
    width: 100% !important;
    padding: 0 0.7rem;
  }
}
@media (min-width: 376px) and (max-width: 574.98px) {
  .custom-container {
    width: 100% !important;
    padding: 0 0.7rem;
  }
}
@media (min-width: 575px) and (max-width: 767.98px) {
  .custom-container {
    width: 100% !important;
    padding: 0 1rem;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .custom-container {
    width: 100% !important;
    padding: 0 1rem;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .custom-container {
    width: 100% !important;
    padding: 0 2.5rem;
  }
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .custom-container {
    width: 100% !important;
    padding: 0 2.5rem;
  }
}
@media (min-width: 1400px) and (max-width: 1599.98px) {
  .custom-container {
    width: 100% !important;
    padding: 0 2.5rem;
  }
}
@media (min-width: 1600px) {
  .custom-container {
    width: 1400px !important;
  }
}

.header .custom-container .header__container .nbr-logo {
  object-fit: contain;
  width: 230px;
}
@media (min-width: 992px) {
  .header .custom-container .header__container .nbr-logo {
    width: 250px;
  }
}
.header .custom-container .header__container .nbr-logo-without-text {
  object-fit: contain;
  width: 42px;
}
@media (min-width: 568px) {
  .header .custom-container .header__container .nbr-logo-without-text {
    width: 50px;
  }
}
.header .custom-container .header__container .bd-customs-logo {
  object-fit: contain;
  width: 50px;
}
@media (min-width: 576px) {
  .header .custom-container .header__container .bd-customs-logo {
    width: 60px;
  }
}
.header .custom-container .header__container .bd-customs-logo-with-text {
  object-fit: contain;
  width: 280px;
}

.navbar {
  z-index: 2;
}
.navbar .navbar-toggler {
  outline: none;
  position: absolute;
  right: 0;
  top: -55px;
}

.navbar-expand-xl {
  padding: 0;
}
@media (max-width: 1199px) {
  .navbar-expand-xl .navbar-collapse {
    position: absolute;
    top: 0;
  }
}
.navbar-expand-xl .navbar-collapse .navbar-nav {
  border-radius: 7px;
  justify-content: space-between;
}
.navbar-expand-xl .navbar-collapse .navbar-nav .nav-item {
  background: #354e80;
  border-radius: 6px;
  border: 2px solid #fff !important;
  flex-grow: 1;
  margin: 0 0.1rem;
  padding: 0.3rem;
  text-align: center;
}
.navbar-expand-xl .navbar-collapse .navbar-nav .nav-item .nav-link {
  color: #fff;
}
.navbar-expand-xl .navbar-collapse .navbar-nav .nav-item .nav-link.active {
  color: #FAE205;
}

@media (min-width: 1600px) {
  .navbar.navbar-expand-xl.px-xl-4 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}

.footer {
  padding: 0;
  background: #fffdef;
  color: #1c2f56;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.footer .copy-right-section {
  background: #1c2f56;
  color: #fff;
  text-align: center;
  padding: 1.3rem 1.2rem 1.2rem 1.2rem;
}
@media (min-width: 576px) {
  .footer .copy-right-section {
    padding: 1.5rem 0 1.2rem 0;
  }
}

.clickable {
  cursor: pointer;
}

.alert {
  padding: 1rem 1.25rem;
}

.one-line-overflow-ellepse {
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
}

.update-btn {
  background: transparent;
  border: 1px solid #fff;
  padding: 0.85rem 2rem;
  text-transform: capitalize;
  border-radius: 6px;
  color: #fff;
  transition: 0.3s;
  font-weight: 500;
}
.update-btn:hover {
  background: #fff;
  color: #323233;
  text-decoration: none;
}
.update-btn:focus {
  outline: none;
}

.delete-btn {
  background: transparent;
  border: 1px solid crimson;
  padding: 0.85rem 2rem;
  text-transform: capitalize;
  border-radius: 6px;
  color: crimson;
  transition: 0.3s;
  font-weight: 500;
}
.delete-btn:hover {
  background: crimson;
  color: #fff;
  text-decoration: none;
}
.delete-btn:focus {
  outline: none;
}

.save-btn {
  background: transparent;
  border: 1px solid darkgreen;
  padding: 0.85rem 2rem;
  text-transform: capitalize;
  border-radius: 6px;
  color: darkgreen;
  transition: 0.3s;
  font-weight: 500;
}
.save-btn:hover {
  background: darkgreen;
  color: #fff;
  text-decoration: none;
}
.save-btn:focus {
  outline: none;
}

.add-btn {
  background: transparent;
  border: 1px solid darkblue;
  padding: 0.85rem 2rem;
  text-transform: capitalize;
  border-radius: 6px;
  color: darkblue;
  transition: 0.3s;
  font-weight: 500;
}
.add-btn:hover {
  background: darkblue;
  color: #fff;
  text-decoration: none;
}
.add-btn:focus {
  outline: none;
}

:root {
  /*===== Colores =====*/
  --first-color: #1a73e8;
  --textarea-color: #80868b;
  --border-color: #dadce0;
  /*===== Fuente y tipografia =====*/
  --body-font: "Roboto", SolaimanLipi, sans-serif;
  --normal-font-size: 1rem;
  --small-font-size: 0.75rem;
}

/*===== BASE =====*/
*,
::before,
::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: var(--body-font);
  font-size: var(--normal-font-size);
}

.form__div--textarea {
  position: relative;
  margin-bottom: 1.5rem;
}

.form__textarea {
  resize: none;
  width: 100%;
  height: 120px;
  font-size: var(--normal-font-size);
  border: 2px solid var(--border-color);
  border-radius: 5px;
  outline: none;
  padding: 1rem;
  background: none;
  z-index: 1;
}

.textarea-form__label {
  position: absolute;
  left: 1rem;
  top: 0.7rem;
  padding: 0 0.25rem;
  background-color: #fff;
  color: var(--textarea-color);
  font-size: var(--normal-font-size);
  transition: 0.3s;
}

/*textarea focus move up label*/
.form__textarea:focus + .textarea-form__label {
  top: -0.35rem;
  left: 0.8rem;
  color: var(--first-color);
  font-size: var(--small-font-size);
  font-weight: 500;
  z-index: 10;
}

/*textarea focus sticky top label*/
.form__textarea:not(:placeholder-shown).form__textarea:not(:focus) + .textarea-form__label {
  top: -0.35rem;
  left: 0.8rem;
  font-size: var(--small-font-size);
  font-weight: 500;
  z-index: 10;
}

/*textarea focus*/
.form__textarea:focus {
  border: 2px solid var(--first-color);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/common/layout.scss","webpack://./src/index.scss","webpack://./src/assets/css/common/_container.scss","webpack://./src/assets/css/common/sections/_header.scss","webpack://./src/assets/css/common/sections/_navbar.scss","webpack://./src/assets/css/common/_variables.scss","webpack://./src/assets/css/common/sections/_footer.scss","webpack://./src/assets/css/common/styles.scss","webpack://./src/assets/css/common/buttons.scss","webpack://./src/assets/css/common/components/_textarea.scss"],"names":[],"mappings":"AAIA;;;EAGE,sBAAA;ACAF;;ADGA;EACE,SAAA;EACA,kDAAA;EACA,eAAA;EACA,gBAAA;ACAF;;ACdA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;ADiBF;ACfE;EANF;IAOI,sBAAA;IACA,iBAAA;EDkBF;AACF;AChBE;EAXF;IAYI,sBAAA;IACA,iBAAA;EDmBF;AACF;ACjBE;EAhBF;IAiBI,sBAAA;IACA,eAAA;EDoBF;AACF;ACnBE;EApBF;IAqBI,sBAAA;IACA,eAAA;EDsBF;AACF;ACrBE;EAxBF;IAyBI,sBAAA;IACA,iBAAA;EDwBF;AACF;ACtBE;EA7BF;IA8BI,sBAAA;IACA,iBAAA;EDyBF;AACF;ACvBE;EAlCF;IAmCI,sBAAA;IACA,iBAAA;ED0BF;AACF;ACxBE;EAvCF;IAwCI,wBAAA;ED2BF;AACF;;AEjEM;EACE,mBAAA;EACA,YAAA;AFoER;AElEQ;EAJF;IAKI,YAAA;EFqER;AACF;AElEM;EACE,mBAAA;EACA,WAAA;AFoER;AElEQ;EAJF;IAKI,WAAA;EFqER;AACF;AElEM;EACE,mBAAA;EACA,WAAA;AFoER;AElEQ;EAJF;IAKI,WAAA;EFqER;AACF;AElEM;EACE,mBAAA;EAEA,YAAA;AFmER;;AGlGA;EACE,UAAA;AHqGF;AGpGE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AHsGJ;;AGlGA;EACE,UAAA;AHqGF;AGnGI;EADF;IAEI,kBAAA;IACA,MAAA;EHsGJ;AACF;AGrGI;EAEE,kBAAA;EACA,8BAAA;AHsGN;AGpGM;EACE,mBCvBK;EDwBL,kBAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AHsGR;AGrGQ;EACE,WAAA;AHuGV;AGrGQ;EACE,cAAA;AHuGV;;AG/FE;EADF;IAEI,0BAAA;IACA,2BAAA;EHmGF;AACF;;AKhJA;EACE,UAAA;EACA,mBAAA;EACA,cDFgB;ECGhB,iDAAA;ALmJF;AKjJE;EACE,mBDNc;ECOd,WAAA;EACA,kBAAA;EACA,oCAAA;ALmJJ;AKjJI;EANF;IAOI,0BAAA;ELoJJ;AACF;;AMpKA;EACE,eAAA;ANuKF;;AMpKA;EACE,qBAAA;ANuKF;;AMhKA;EACE,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;ANmKF;;AOrLA;EACE,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;APwLF;AOtLE;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;APwLJ;AOrLE;EACE,aAAA;APuLJ;;AOnLA;EACE,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;APsLF;AOpLE;EACE,mBAAA;EACA,WAAA;EACA,qBAAA;APsLJ;AOnLE;EACE,aAAA;APqLJ;;AOjLA;EACE,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;APoLF;AOlLE;EACE,qBAAA;EACA,WAAA;EACA,qBAAA;APoLJ;AOjLE;EACE,aAAA;APmLJ;;AO/KA;EACE,uBAAA;EACA,0BAAA;EACA,qBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;APkLF;AOhLE;EACE,oBAAA;EACA,WAAA;EACA,qBAAA;APkLJ;AO/KE;EACE,aAAA;APiLJ;;AQjQA;EACE,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EAEA,kCAAA;EACA,+CAAA;EACA,wBAAA;EACA,0BAAA;ARmQF;;AQhQA,mBAAA;AACA;;;EAGE,sBAAA;ARmQF;;AQjQA;EACE,SAAA;EACA,UAAA;EACA,6BAAA;EACA,kCAAA;ARoQF;;AQlQA;EACE,kBAAA;EACA,qBAAA;ARqQF;;AQnQA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,kCAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;ARsQF;;AQpQA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;EACA,kCAAA;EACA,gBAAA;ARuQF;;AQrQA,+BAAA;AACA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;ARwQF;;AQrQA,kCAAA;AACA;EAEE,aAAA;EACA,YAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;ARuQF;;AQpQA,iBAAA;AACA;EACE,oCAAA;ARuQF","sourcesContent":["@import url(\"https://fonts.maateen.me/solaiman-lipi/font.css\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap\");\r\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap\");\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: \"Poppins\", \"SolaimanLipi\", sans-serif;\r\n  font-size: 1rem;\r\n  line-height: 1.3;\r\n}\r\n\r\n@import \"container\";\r\n@import \"sections/header\";\r\n@import \"sections/navbar\";\r\n@import \"sections/footer\";\r\n@import \"styles\";\r\n@import \"buttons\";\r\n@import \"./components/textarea\";\r\n","@import url(\"https://fonts.maateen.me/solaiman-lipi/font.css\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap\");\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Poppins\", \"SolaimanLipi\", sans-serif;\n  font-size: 1rem;\n  line-height: 1.3;\n}\n\n.custom-container {\n  width: 100%;\n  height: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (max-width: 375.98px) {\n  .custom-container {\n    width: 100% !important;\n    padding: 0 0.7rem;\n  }\n}\n@media (min-width: 376px) and (max-width: 574.98px) {\n  .custom-container {\n    width: 100% !important;\n    padding: 0 0.7rem;\n  }\n}\n@media (min-width: 575px) and (max-width: 767.98px) {\n  .custom-container {\n    width: 100% !important;\n    padding: 0 1rem;\n  }\n}\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .custom-container {\n    width: 100% !important;\n    padding: 0 1rem;\n  }\n}\n@media (min-width: 992px) and (max-width: 1199.98px) {\n  .custom-container {\n    width: 100% !important;\n    padding: 0 2.5rem;\n  }\n}\n@media (min-width: 1200px) and (max-width: 1399.98px) {\n  .custom-container {\n    width: 100% !important;\n    padding: 0 2.5rem;\n  }\n}\n@media (min-width: 1400px) and (max-width: 1599.98px) {\n  .custom-container {\n    width: 100% !important;\n    padding: 0 2.5rem;\n  }\n}\n@media (min-width: 1600px) {\n  .custom-container {\n    width: 1400px !important;\n  }\n}\n\n.header .custom-container .header__container .nbr-logo {\n  object-fit: contain;\n  width: 230px;\n}\n@media (min-width: 992px) {\n  .header .custom-container .header__container .nbr-logo {\n    width: 250px;\n  }\n}\n.header .custom-container .header__container .nbr-logo-without-text {\n  object-fit: contain;\n  width: 42px;\n}\n@media (min-width: 568px) {\n  .header .custom-container .header__container .nbr-logo-without-text {\n    width: 50px;\n  }\n}\n.header .custom-container .header__container .bd-customs-logo {\n  object-fit: contain;\n  width: 50px;\n}\n@media (min-width: 576px) {\n  .header .custom-container .header__container .bd-customs-logo {\n    width: 60px;\n  }\n}\n.header .custom-container .header__container .bd-customs-logo-with-text {\n  object-fit: contain;\n  width: 280px;\n}\n\n.navbar {\n  z-index: 2;\n}\n.navbar .navbar-toggler {\n  outline: none;\n  position: absolute;\n  right: 0;\n  top: -55px;\n}\n\n.navbar-expand-xl {\n  padding: 0;\n}\n@media (max-width: 1199px) {\n  .navbar-expand-xl .navbar-collapse {\n    position: absolute;\n    top: 0;\n  }\n}\n.navbar-expand-xl .navbar-collapse .navbar-nav {\n  border-radius: 7px;\n  justify-content: space-between;\n}\n.navbar-expand-xl .navbar-collapse .navbar-nav .nav-item {\n  background: #354e80;\n  border-radius: 6px;\n  border: 2px solid #fff !important;\n  flex-grow: 1;\n  margin: 0 0.1rem;\n  padding: 0.3rem;\n  text-align: center;\n}\n.navbar-expand-xl .navbar-collapse .navbar-nav .nav-item .nav-link {\n  color: #fff;\n}\n.navbar-expand-xl .navbar-collapse .navbar-nav .nav-item .nav-link.active {\n  color: #FAE205;\n}\n\n@media (min-width: 1600px) {\n  .navbar.navbar-expand-xl.px-xl-4 {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n\n.footer {\n  padding: 0;\n  background: #fffdef;\n  color: #1c2f56;\n  font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\n}\n.footer .copy-right-section {\n  background: #1c2f56;\n  color: #fff;\n  text-align: center;\n  padding: 1.3rem 1.2rem 1.2rem 1.2rem;\n}\n@media (min-width: 576px) {\n  .footer .copy-right-section {\n    padding: 1.5rem 0 1.2rem 0;\n  }\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.alert {\n  padding: 1rem 1.25rem;\n}\n\n.one-line-overflow-ellepse {\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n  -webkit-box-orient: vertical;\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.update-btn {\n  background: transparent;\n  border: 1px solid #fff;\n  padding: 0.85rem 2rem;\n  text-transform: capitalize;\n  border-radius: 6px;\n  color: #fff;\n  transition: 0.3s;\n  font-weight: 500;\n}\n.update-btn:hover {\n  background: #fff;\n  color: #323233;\n  text-decoration: none;\n}\n.update-btn:focus {\n  outline: none;\n}\n\n.delete-btn {\n  background: transparent;\n  border: 1px solid crimson;\n  padding: 0.85rem 2rem;\n  text-transform: capitalize;\n  border-radius: 6px;\n  color: crimson;\n  transition: 0.3s;\n  font-weight: 500;\n}\n.delete-btn:hover {\n  background: crimson;\n  color: #fff;\n  text-decoration: none;\n}\n.delete-btn:focus {\n  outline: none;\n}\n\n.save-btn {\n  background: transparent;\n  border: 1px solid darkgreen;\n  padding: 0.85rem 2rem;\n  text-transform: capitalize;\n  border-radius: 6px;\n  color: darkgreen;\n  transition: 0.3s;\n  font-weight: 500;\n}\n.save-btn:hover {\n  background: darkgreen;\n  color: #fff;\n  text-decoration: none;\n}\n.save-btn:focus {\n  outline: none;\n}\n\n.add-btn {\n  background: transparent;\n  border: 1px solid darkblue;\n  padding: 0.85rem 2rem;\n  text-transform: capitalize;\n  border-radius: 6px;\n  color: darkblue;\n  transition: 0.3s;\n  font-weight: 500;\n}\n.add-btn:hover {\n  background: darkblue;\n  color: #fff;\n  text-decoration: none;\n}\n.add-btn:focus {\n  outline: none;\n}\n\n:root {\n  /*===== Colores =====*/\n  --first-color: #1a73e8;\n  --textarea-color: #80868b;\n  --border-color: #dadce0;\n  /*===== Fuente y tipografia =====*/\n  --body-font: \"Roboto\", SolaimanLipi, sans-serif;\n  --normal-font-size: 1rem;\n  --small-font-size: 0.75rem;\n}\n\n/*===== BASE =====*/\n*,\n::before,\n::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: var(--body-font);\n  font-size: var(--normal-font-size);\n}\n\n.form__div--textarea {\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n\n.form__textarea {\n  resize: none;\n  width: 100%;\n  height: 120px;\n  font-size: var(--normal-font-size);\n  border: 2px solid var(--border-color);\n  border-radius: 5px;\n  outline: none;\n  padding: 1rem;\n  background: none;\n  z-index: 1;\n}\n\n.textarea-form__label {\n  position: absolute;\n  left: 1rem;\n  top: 0.7rem;\n  padding: 0 0.25rem;\n  background-color: #fff;\n  color: var(--textarea-color);\n  font-size: var(--normal-font-size);\n  transition: 0.3s;\n}\n\n/*textarea focus move up label*/\n.form__textarea:focus + .textarea-form__label {\n  top: -0.35rem;\n  left: 0.8rem;\n  color: var(--first-color);\n  font-size: var(--small-font-size);\n  font-weight: 500;\n  z-index: 10;\n}\n\n/*textarea focus sticky top label*/\n.form__textarea:not(:placeholder-shown).form__textarea:not(:focus) + .textarea-form__label {\n  top: -0.35rem;\n  left: 0.8rem;\n  font-size: var(--small-font-size);\n  font-weight: 500;\n  z-index: 10;\n}\n\n/*textarea focus*/\n.form__textarea:focus {\n  border: 2px solid var(--first-color);\n}",".custom-container {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n\r\n  @media (max-width: 375.98px) {\r\n    width: 100% !important;\r\n    padding: 0 0.7rem;\r\n  }\r\n\r\n  @media (min-width: 376px) and (max-width: 574.98px) {\r\n    width: 100% !important;\r\n    padding: 0 0.7rem;\r\n  }\r\n\r\n  @media (min-width: 575px) and (max-width: 767.98px) {\r\n    width: 100% !important;\r\n    padding: 0 1rem;\r\n  }\r\n  @media (min-width: 768px) and (max-width: 991.98px) {\r\n    width: 100% !important;\r\n    padding: 0 1rem;\r\n  }\r\n  @media (min-width: 992px) and (max-width: 1199.98px) {\r\n    width: 100% !important;\r\n    padding: 0 2.5rem;\r\n  }\r\n\r\n  @media (min-width: 1200px) and (max-width: 1399.98px) {\r\n    width: 100% !important;\r\n    padding: 0 2.5rem;\r\n  }\r\n\r\n  @media (min-width: 1400px) and (max-width: 1599.98px) {\r\n    width: 100% !important;\r\n    padding: 0 2.5rem;\r\n  }\r\n\r\n  @media (min-width: 1600px) {\r\n    width: 1400px !important;\r\n  }\r\n}\r\n",".header {\r\n  .custom-container {\r\n    .header__container {\r\n      .nbr-logo {\r\n        object-fit: contain;\r\n        width: 230px;\r\n\r\n        @media (min-width: 992px) {\r\n          width: 250px;\r\n        }\r\n      }\r\n\r\n      .nbr-logo-without-text{\r\n        object-fit: contain;\r\n        width: 42px;\r\n\r\n        @media (min-width: 568px) {\r\n          width: 50px;\r\n        }\r\n      }\r\n\r\n      .bd-customs-logo {\r\n        object-fit: contain;\r\n        width: 50px;\r\n\r\n        @media (min-width: 576px) {\r\n          width: 60px;\r\n        }\r\n      }\r\n\r\n      .bd-customs-logo-with-text {\r\n        object-fit: contain;\r\n        //width: 170px;\r\n        width: 280px;\r\n      }\r\n    }\r\n  }\r\n}\r\n","@import \"../variables\";\r\n\r\n.navbar {\r\n  z-index: 2;\r\n  .navbar-toggler {\r\n    outline: none;\r\n    position: absolute;\r\n    right: 0;\r\n    top: -55px;\r\n  }\r\n}\r\n\r\n.navbar-expand-xl {\r\n  padding: 0;\r\n  .navbar-collapse {\r\n    @media (max-width: 1199px) {\r\n      position: absolute;\r\n      top: 0;\r\n    }\r\n    .navbar-nav {\r\n      //background-color: rgba(53, 78, 128, 0.5);\r\n      border-radius: 7px;\r\n      justify-content: space-between;\r\n\r\n      .nav-item {\r\n        background: $color-blue;\r\n        border-radius: 6px;\r\n        border: 2px solid #fff !important;\r\n        flex-grow: 1;\r\n        margin: 0 0.1rem;\r\n        padding: .3rem;\r\n        text-align: center;\r\n        .nav-link {\r\n          color: #fff;\r\n        }\r\n        .nav-link.active {\r\n          color: #FAE205;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.navbar.navbar-expand-xl.px-xl-4 {\r\n  @media (min-width: 1600px) {\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n","@import \"../variables\";\r\n\r\n.footer {\r\n  padding: 0;\r\n  background: #fffdef;\r\n  color: $color-blue-dark;\r\n  font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n\r\n  .copy-right-section {\r\n    background: $color-blue-dark;\r\n    color: #fff;\r\n    text-align: center;\r\n    padding: 1.3rem 1.2rem 1.2rem 1.2rem;\r\n\r\n    @media (min-width: 576px) {\r\n      padding: 1.5rem 0 1.2rem 0;\r\n    }\r\n  }\r\n}\r\n",".clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.alert {\r\n  padding: 1rem 1.25rem;\r\n}\r\n\r\n//.tox-notifications-container {\r\n//  display: none;\r\n//}\r\n\r\n.one-line-overflow-ellepse{\r\n  -webkit-line-clamp: 1;\r\n  line-clamp: 1;\r\n  -webkit-box-orient: vertical;\r\n  display: -webkit-box;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n",".update-btn {\r\n  background: transparent;\r\n  border: 1px solid #fff;\r\n  padding: .85rem 2rem;\r\n  text-transform: capitalize;\r\n  border-radius: 6px;\r\n  color: #fff;\r\n  transition: .3s;\r\n  font-weight: 500;\r\n\r\n  &:hover {\r\n    background: #fff;\r\n    color: #323233;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.delete-btn {\r\n  background: transparent;\r\n  border: 1px solid crimson;\r\n  padding: .85rem 2rem;\r\n  text-transform: capitalize;\r\n  border-radius: 6px;\r\n  color: crimson;\r\n  transition: .3s;\r\n  font-weight: 500;\r\n\r\n  &:hover {\r\n    background: crimson;\r\n    color: #fff;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.save-btn {\r\n  background: transparent;\r\n  border: 1px solid darkgreen;\r\n  padding: .85rem 2rem;\r\n  text-transform: capitalize;\r\n  border-radius: 6px;\r\n  color: darkgreen;\r\n  transition: .3s;\r\n  font-weight: 500;\r\n\r\n  &:hover {\r\n    background: darkgreen;\r\n    color: #fff;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.add-btn {\r\n  background: transparent;\r\n  border: 1px solid darkblue;\r\n  padding: .85rem 2rem;\r\n  text-transform: capitalize;\r\n  border-radius: 6px;\r\n  color: darkblue;\r\n  transition: .3s;\r\n  font-weight: 500;\r\n\r\n  &:hover {\r\n    background: darkblue;\r\n    color: #fff;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    outline: none;\r\n  }\r\n}\r\n",":root {\r\n  /*===== Colores =====*/\r\n  --first-color: #1a73e8;\r\n  --textarea-color: #80868b;\r\n  --border-color: #dadce0;\r\n\r\n  /*===== Fuente y tipografia =====*/\r\n  --body-font: \"Roboto\", SolaimanLipi, sans-serif;\r\n  --normal-font-size: 1rem;\r\n  --small-font-size: 0.75rem;\r\n}\r\n\r\n/*===== BASE =====*/\r\n*,\r\n::before,\r\n::after {\r\n  box-sizing: border-box;\r\n}\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: var(--body-font);\r\n  font-size: var(--normal-font-size);\r\n}\r\n.form__div--textarea {\r\n  position: relative;\r\n  margin-bottom: 1.5rem;\r\n}\r\n.form__textarea {\r\n  resize: none;\r\n  width: 100%;\r\n  height: 120px;\r\n  font-size: var(--normal-font-size);\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 5px;\r\n  outline: none;\r\n  padding: 1rem;\r\n  background: none;\r\n  z-index: 1;\r\n}\r\n.textarea-form__label {\r\n  position: absolute;\r\n  left: 1rem;\r\n  top: 0.7rem;\r\n  padding: 0 0.25rem;\r\n  background-color: #fff;\r\n  color: var(--textarea-color);\r\n  font-size: var(--normal-font-size);\r\n  transition: 0.3s;\r\n}\r\n/*textarea focus move up label*/\r\n.form__textarea:focus + .textarea-form__label {\r\n  top: -0.35rem;\r\n  left: 0.8rem;\r\n  color: var(--first-color);\r\n  font-size: var(--small-font-size);\r\n  font-weight: 500;\r\n  z-index: 10;\r\n}\r\n\r\n/*textarea focus sticky top label*/\r\n.form__textarea:not(:placeholder-shown).form__textarea:not(:focus)\r\n  + .textarea-form__label {\r\n  top: -0.35rem;\r\n  left: 0.8rem;\r\n  font-size: var(--small-font-size);\r\n  font-weight: 500;\r\n  z-index: 10;\r\n}\r\n\r\n/*textarea focus*/\r\n.form__textarea:focus {\r\n  border: 2px solid var(--first-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
